module.exports = __webpack_public_path__ + "static/img/fish32.e715cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish32.png
// module id = UmEy
// module chunks = 0